let styles = {
  footer: {
    marginTop: 50,
    position: 'relative',
  }
};

export default styles;